import React, { useState, useEffect } from "react";
import {
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebook,
  FaInstagram,
  FaGoogle,
  FaWhatsapp,
} from "react-icons/fa";
import { motion } from "framer-motion";
import bg1 from "../assets/bg1.jpg";
import bg2 from "../assets/bg2.jpg";
import bg3 from "../assets/bg3.jpg";
import bg5 from "../assets/bg5.jpg";

const images = [bg1, bg2, bg3, bg5];

const Contact = () => {
  const [bgImage, setBgImage] = useState(images[0]);
  const [bgIndex, setBgIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setBgIndex((prevIndex) => {
        const newIndex = (prevIndex + 1) % images.length;
        setBgImage(images[newIndex]);
        return newIndex;
      });
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="text-center jost">
      <motion.div
        className="relative h-96 bg-cover bg-center"
        style={{ backgroundImage: `url(${bgImage})` }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="absolute inset-0 bg-[#000000] bg-opacity-10 flex items-center justify-center flex-col text-center">
          <h1 className="text-[#fcc11b] text-4xl font-bold mb-4 mt-12">
            Contact Us
          </h1>
        </div>
      </motion.div>
      <div className="container mx-auto px-4 py-8">
        <h2 className="text-2xl text-center underline underline-offset-2 font-bold mb-4">
          Get in Touch
        </h2>

        <div className="flex flex-col items-center space-y-4 mt-8">
          <motion.div
            whileHover={{
              scale: 1.1,
              translateZ: 50,
              perspective: 1000,
              boxShadow: "0px 20px 30px rgba(0, 0, 0, 0.4)",
              transition: { duration: 0.2 },
            }}
            className="inline-block mb-4"
          >
            <a
              href="sms:+12065308861?&body=Hi,%20I%20am%20interested%20in%20a%20project%20from%20Fixit%20Handyman.%20Project%20Details:"
              className="bg-[#fcc11b] text-[#000000] px-4 py-2 rounded font-bold"
            >
              <span>📞</span> <span>(206) 530-8861</span>
            </a>
          </motion.div>
          <motion.div className="flex items-center space-x-2">
            <FaMapMarkerAlt className="text-[#fcc11b]" />
            <p className="text-lg">We serve the whole Puget Sound Area!</p>
          </motion.div>
          <motion.div
            className="flex items-center space-x-2"
            whileHover={{
              scale: 1.1,
              translateZ: 50,
              perspective: 1000,
              transition: { duration: 0.2 },
            }}
          >
            <FaEnvelope className="text-[#fcc11b]" />
            <a
              href="mailto:fixithandyman.us@outlook.com"
              className="bg-[#fcc11b] text-[#000000] px-4 py-2 rounded font-bold"
            >
              <span>fixithandyman.us@outlook.com</span>
            </a>
          </motion.div>
        </div>
        <div className="flex justify-center space-x-4 mt-6">
          <a
            href="https://www.facebook.com/profile.php?id=100087216231259&rdid=mJAv25QiFNIyB8bH&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F15TM46zeRW%2F#"
            target="_blank"
            rel="noreferrer"
            className="text-[#fcc11b] hover:text-[#000000]"
          >
            <FaFacebook size={40} />
          </a>
        </div>
        <motion.div
          className="flex items-center justify-center mx-auto mt-4 space-x-2"
          whileHover={{
            scale: 1.1,
            translateZ: 50,
            perspective: 1000,
            transition: { duration: 0.2 },
          }}
        >
          <FaWhatsapp size={40} className="text-[#fcc11b]" />
          <a
            href="https://api.whatsapp.com/send?phone=12065308861&text=Hi,%20I%20am%20interested%20in%20a%20project%20from%20Fixit%20Handyman.%20Project%20Details:"
            target="_blank"
            rel="noreferrer"
             className="bg-[#fcc11b] text-[#000000] px-4 py-2 rounded font-bold"
          >
            <span>WhatsApp Business Chat</span>
          </a>
        </motion.div>
        <motion.div
          className="flex items-center justify-center mx-auto mt-4 space-x-2"
          whileHover={{
            scale: 1.1,
            translateZ: 50,
            perspective: 1000,
            transition: { duration: 0.2 },
          }}
        >
          <FaGoogle className="text-[#fcc11b]" />
          <a
            href="https://www.google.com/maps/place/Fixit+Handyman+Home+Services+LLC/@47.5672454,-122.0882511,17z/data=!3m1!4b1!4m6!3m5!1s0x54906fda38d5368b:0x4d06b27360a05d1a!8m2!3d47.5672454!4d-122.0856762!16s%2Fg%2F11vq8q12_h?entry=ttu&g_ep=EgoyMDI1MDQwMi4xIKXMDSoJLDEwMjExNDUzSAFQAw%3D%3D"
            className="bg-[#fcc11b] text-[#000000] px-4 py-2 rounded font-bold"
          >
            <span>View Reviews</span>
          </a>
        </motion.div>
      </div>
    </div>
  );
};

export default Contact;
